import { Box } from '@mui/material';

export const TabPanel = props => {
  const { children, value, index, id, ariaLabel, boxPadding, padding, ...other } = props;

  return (
    <div role="tabpanel" hidden={value !== index} id={id} aria-labelledby={ariaLabel} {...other}>
      {value === index && (
        <Box
          sx={{
            p: boxPadding ?? 3,
            '&.MuiBox-root': {
              padding: padding,
            },
          }}
        >
          {children}
        </Box>
      )}
    </div>
  );
};
